/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OperationsRow,
    OperationsRowFromJSON,
    OperationsRowFromJSONTyped,
    OperationsRowToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2003Data
 */
export interface InlineResponse2003Data {
    /**
     * 
     * @type {Array<OperationsRow>}
     * @memberof InlineResponse2003Data
     */
    list: Array<OperationsRow>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003Data
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003Data
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003Data
     */
    maxPage: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003Data
     */
    totalSize: number;
}

export function InlineResponse2003DataFromJSON(json: any): InlineResponse2003Data {
    return InlineResponse2003DataFromJSONTyped(json, false);
}

export function InlineResponse2003DataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2003Data {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(OperationsRowFromJSON)),
        'page': json['page'],
        'size': json['size'],
        'maxPage': json['maxPage'],
        'totalSize': json['totalSize'],
    };
}

export function InlineResponse2003DataToJSON(value?: InlineResponse2003Data | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(OperationsRowToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


